import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecord = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 0 24 24",
	width: "24px",
	fill: "currentColor",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M24 24H0V0h24v24z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 8
		})
	]
});
const ForwardRef = forwardRef(SvgRecord);
export default ForwardRef;
